import * as React from "react"
import { AutocompleteAsyncSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { brand } from "@signals"


export default function DIPBrandAsync({ ...props }) {
    return <AutocompleteAsyncSeeker
        multiple
        urlAjax={`${BACKEND_APIS.MASTER_DATA}/brand/wrapped/find-options`}
        label="Brands"
        placeholder="Search Brand..."
        value={brand.value}
        onChange={e => brand.value = e.target.value}
        {...props}
    />
}
